module.exports = __webpack_public_path__ + "img/no-image.08441b70.png";